import WrapperService from '@/modules/core/services/wrapper-service';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/province';

const serviceName = "Province-Service: ";

export default class ProvinceService {

    static async readCountryProvince(successF, errorF) {
        await WrapperService.get(API_URL + '/country-province', null, serviceName, successF, errorF);
    }
}